<ng-container [formGroup]="model">
  @if (photoType === 'school' && organizationSettings) {
    <div
      class="school-photo-picker"
      >
      @if (organizationSettings.photo1?.fileName) {
        <img
          [ngClass]="{ picked: model.value.schoolPhotoNumber === 1 }"
      (click)="
        model.patchValue({
          schoolPhotoNumber: 1,
          scale: 1,
          y: $safeNavigationMigration(organizationSettings.photo1?.y),
          x: $safeNavigationMigration(organizationSettings.photo1?.x),
          width: $safeNavigationMigration(organizationSettings.photo1?.width),
          height: $safeNavigationMigration(organizationSettings.photo1?.height),
          fileName: $safeNavigationMigration(organizationSettings.photo1?.fileName)
        })
      "
      [src]="
        $safeNavigationMigration(organizationSettings.photo1?.fileName) | publicImageUrl: 500:500 | async
      "
          />
      }
      @if (organizationSettings.photo2?.fileName) {
        <img
          [ngClass]="{ picked: model.value.schoolPhotoNumber === 2 }"
      (click)="
        model.patchValue({
          schoolPhotoNumber: 2,
          scale: 1,
          y: $safeNavigationMigration(organizationSettings.photo2?.y),
          x: $safeNavigationMigration(organizationSettings.photo2?.x),
          width: $safeNavigationMigration(organizationSettings.photo2?.width),
          height: $safeNavigationMigration(organizationSettings.photo2?.height),
          fileName: $safeNavigationMigration(organizationSettings.photo2?.fileName)
        })
      "
      [src]="
        $safeNavigationMigration(organizationSettings.photo2?.fileName) | publicImageUrl: 500:500 | async
      "
          />
        }@if (organizationSettings.photo3?.fileName) {
        <img
          [ngClass]="{ picked: model.value.schoolPhotoNumber === 3 }"
      (click)="
        model.patchValue({
          schoolPhotoNumber: 3,
          scale: 1,
          y: $safeNavigationMigration(organizationSettings.photo3?.y),
          x: $safeNavigationMigration(organizationSettings.photo3?.x),
          width: $safeNavigationMigration(organizationSettings.photo3?.width),
          height: $safeNavigationMigration(organizationSettings.photo3?.height),
          fileName: $safeNavigationMigration(organizationSettings.photo3?.fileName)
        })
      "
      [src]="
        $safeNavigationMigration(organizationSettings.photo3?.fileName) | publicImageUrl: 500:500 | async
      "
          />
      }
    </div>
  }

  @if (photoType === 'child') {
    @if (!model.value.photoId) {
      <lib-button (click)="pickPhoto()"
        >Wybierz zdjęcie
      </lib-button>
    }
    @if (model.value.photoId) {
      <div class="photoContainer">
        <div class="placeholder">
          <lib-tablo-smart-crop
            [selectedPoint]="true"
            [x]="model.value.x"
            [y]="model.value.y"
            (updatedEmitter)="
              model.patchValue({
                x: $event.x,
                y: $event.y
              })
            "
            [imageSize]="{
              w: model.value.width,
              h: model.value.height
            }"
            [url]="
              {
                photoId: model.value.photoId
              }
                | getImageUrl
                  : model.value.photoGroupId
                  : 'photographer'
                  : context
                  : contextId
                  : 600
                | async
            "
        ></lib-tablo-smart-crop>
      </div>
    </div>
    <input type="range" formControlName="scale" min="1" max="3" step="0.01" />
    <lib-button (click)="pickPhoto()">Wybierz inne zdjęcie</lib-button>
  }
}
<app-change-number
  formControlName="childPhotoFrameWidth"
  [minNumber]="0"
  [maxLabelWidth]="true"
  >Grubość ramki zdjęcia
</app-change-number>
@if (model.value['childPhotoFrameWidth']) {
  <div class="colorPicker">
    Kolor ramki:
    <input
      #me
      (colorPickerChange)="
        model.controls['childPhotoFrameColor'].patchValue($event)
      "
      [(colorPicker)]="model.value['childPhotoFrameColor']"
      [cpUseRootViewContainer]="true"
      [style.background]="
        me.value ? me.value : model.value['childPhotoFrameColor']
      "
      />
    </div>
  }
  <lib-box-shadow-editor formControlName="childPhotoShadow">
    Cieniowanie
  </lib-box-shadow-editor>

  <lib-single-file-uploader
    [reverseLabel]="true"
    [context]="uploadContextForAssets"
    [contextId]="projectId"
    [maxLabelWidth]="true"
    [size]="50"
    formControlName="childPhotoOverlayFileName"
    >
    <label>Nakładka nad zdjęciem</label>
  </lib-single-file-uploader>
  @if (model.value.childPhotoOverlayFileName) {
    <app-change-number
      formControlName="childPhotoOverlayScale"
      [minNumber]="0"
      [maxLabelWidth]="true"
      [step]="0.01"
      >Rozmiar nakładki
    </app-change-number>
  }
  @if (!model.value.photoAsSquare) {
    <lib-checkbox
      formControlName="photoAsCircle"
      >Zdjęcie jako okrąg
    </lib-checkbox>
  }
  @if (!model.value.photoAsCircle) {
    <lib-checkbox
      formControlName="photoAsSquare"
      >Zdjęcie jako kwadrat
    </lib-checkbox>
  }

  <app-change-number
    formControlName="childRadius"
    [minNumber]="0"
    [maxLabelWidth]="true"
    [maxNumber]="500"
    >Zaokrąglenie
  </app-change-number>
</ng-container>
